import './chart-controls-element';
import './chart-element';

import { LitElement, html } from 'lit';
import { property, state, customElement } from 'lit/decorators.js';

import type { ChartSeriesData } from './chart-element';

export interface ChartCategoryChangeEvent {
	detail: {
		newState: number;
	};
}

@customElement('chart-container-element')
export class ChartContainerElement extends LitElement {
	@property({ type: String })
	locale: 'en-CA' | 'en-US' | 'es-US' = 'en-US';

	@property({ type: Array })
	chartSeriesData: ChartSeriesData[] = [];

	// Enable the population health labels (Less Symptoms/More Symptoms instead of numbers)
	@property({ type: Boolean })
	enableSymptomsLabels = false;

	@property({ type: Boolean })
	showTooltips = false;

	@property({ type: Boolean })
	showStartingPoint = false;

	@property({ type: Boolean })
	showCustomLegendIcons = false;

	@state()
	private index = 0;

	// To allow Bootstrap css
	createRenderRoot() {
		return this;
	}

	render() {
		return html`
			<chart-controls-element
				.categories=${this.chartSeriesData.map((category) => category.name)}
				@chart.category.change=${this._handleChartCategoryChange}
			></chart-controls-element>
			<chart-element
				.chartSeriesData=${[this.chartSeriesData[this.index]]}
				.locale=${this.locale}
				.showTooltips=${this.showTooltips}
				.showStartingPoint=${this.showStartingPoint}
				.enableSymptomsLabels=${this.enableSymptomsLabels}
				.showCustomLegendIcons=${this.showCustomLegendIcons}
			></chart-element>
		`;
	}

	/**
	 * Handles the `chart.category.change` event from `chart-controls-element`.
	 */
	private _handleChartCategoryChange(event: ChartCategoryChangeEvent) {
		const { newState } = event.detail;
		this.index = newState;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'chart-container-element': ChartContainerElement;
	}
}
